"use strict";

import { userConstants } from "../_constants";

export const getUserLatestAchievementsRequest = (payload) => {
    return {
        type: userConstants.USER_GET_LATEST_ACHIEVEMENTS_REQUEST,
        payload,
    };
};

export const getUserLatestAchievementsComplete = (payload) => {
    return {
        type: userConstants.USER_GET_LATEST_ACHIEVEMENTS_COMPLETE,
        payload,
    };
};

export const getUserThingsToDoRequest = (payload) => {
    return {
        type: userConstants.USER_GET_THINGS_TO_DO_REQUEST,
        payload,
    };
};

export const getUserThingsToDoComplete = (payload) => {
    return {
        type: userConstants.USER_GET_THINGS_TO_DO_COMPLETE,
        payload,
    };
};

export const getUserMebershipRequest = (payload) => {
    return {
        type: userConstants.USER_MEMBERSHIP_REQUEST,
        payload,
    };
};

export const getUserMebershipComplete = (payload) => {
    return {
        type: userConstants.USER_MEMBERSHIP_COMPLETE,
        payload,
    };
};

export const getUserPointsTransactionsRequest = (payload) => {
    return {
        type: userConstants.USER_POINTS_TRANSACTIONS_REQUEST,
        payload,
    };
};

export const getUserPointsTransactionsComplete = (payload) => {
    return {
        type: userConstants.USER_POINTS_TRANSACTIONS_COMPLETE,
        payload,
    };
};

export const getUserGoalsRequest = (payload) => {
    return {
        type: userConstants.USER_GOALS_REQUEST,
        payload,
    };
};

export const getUserGoalsComplete = (payload) => {
    return {
        type: userConstants.USER_GOALS_COMPLETE,
        payload,
    };
};

export const getUserIncentiveHistoryRequest = (payload) => {
    return {
        type: userConstants.USER_INCENTIVE_HISTORY_REQUEST,
        payload,
    };
};

export const getUserIncentiveHistoryComplete = (payload) => {
    return {
        type: userConstants.USER_INCENTIVE_HISTORY_COMPLETE,
        payload,
    };
};

export const getParticipantNotificationRequest = (payload) => {
    return {
        type: userConstants.GET_PARTICIPANT_NOTIFICATION_REQUEST,
        payload,
    };
};

export const getParticipantNotificationComplete = (payload) => {
    return {
        type: userConstants.GET_PARTICIPANT_NOTIFICATION_COMPLETE,
        payload,
    };
};

export const getNewsFeedRequest = (payload) => {
    return {
        type: userConstants.GET_NEWS_FEED_REQUEST,
        payload,
    };
};

export const getNewsFeedComplete = (payload) => {
    return {
        type: userConstants.GET_NEWS_FEED_COMPLETE,
        payload,
    };
};

export const readNotificationRequest = (payload) => {
    return {
        type: userConstants.READ_NOTIFICATION_REQUEST,
        payload,
    };
};

export const readNotificationComplete = (payload) => {
    return {
        type: userConstants.READ_NOTIFICATION_COMPLETE,
        payload,
    };
};

export const getUserPointsBalanceRequest = (payload) => {
    return {
        type: userConstants.GET_USER_POINTS_BALANCE_REQUEST,
        payload,
    };
};

export const getUserPointsBalanceComplete = (payload) => {
    return {
        type: userConstants.GET_USER_POINTS_BALANCE_COMPLETE,
        payload,
    };
};

export const getLatestTransactionRequest = (payload) => {
    return {
        type: userConstants.GET_LATEST_TRANSACTIONS_REQUEST,
        payload,
    };
};

export const getLatestTransactionComplete = (payload) => {
    return {
        type: userConstants.GET_LATEST_TRANSACTIONS_COMPLETE,
        payload,
    };
};

export const userAccountLogUserLogStatusRequest = (payload) => {
    return {
        type: userConstants.USER_ACCOUNT_LOG_USER_STATUS_REQUEST,
        payload,
    };
};

export const userAccountLogUserLogStatusComplete = (payload) => {
    return {
        type: userConstants.USER_ACCOUNT_LOG_USER_STATUS_COMPLETE,
        payload,
    };
};
